import script from "./NewForgotPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewForgotPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewForgotPasswordForm.vue?vue&type=style&index=0&id=8042bb50&lang=css"

const __exports__ = script;

export default __exports__